const onPremDevDomain = 'https://wwwdev.troweprice.com';

export default {
  DEV: {
    INTERNAL: {
      api: 'https://api.dev.awstrp.net',
      web: 'https://www.dev.awstrp.net',
      wrs: onPremDevDomain,
    },
    EXTERNAL: {
      api: 'https://api.dev.troweprice.com',
      web: 'https://wwwdev.troweprice.com',
      wrs: onPremDevDomain,
    },
  },
  STAGE: {
    INTERNAL: {
      api: 'https://api.stage.awstrp.net',
      web: 'https://www.stage.awstrp.net',
      wrs: 'https://www.stage.awstrp.net',
    },
    EXTERNAL: {
      api: 'https://api.confidence.troweprice.com',
      web: 'https://wwwstage.troweprice.com',
      wrs: 'https://wwwstage.troweprice.com',
    },
  },
  PROD: {
    INTERNAL: {
      api: 'https://api.prod.awstrp.net',
      web: 'https://www.prod.awstrp.net',
      wrs: 'https://www.troweprice.com',
    },
    EXTERNAL: {
      api: 'https://api.public.troweprice.com',
      web: 'https://www.troweprice.com',
      wrs: 'https://www.troweprice.com',
    },
  },
  SANDBOX: {
    EXTERNAL: {
      api: 'https://api.dev.troweprice.com',
      web: 'https://wwwdev.troweprice.com',
      wrs: onPremDevDomain,
    },
  },
};
